<template>
  <div class='main'>
    <div class="check_top">
      <div>
        <el-cascader
          :options="classList"
          v-model="checkParams.classid"
          @change="GetExamSumDataByClass"
          placeholder="请选择班级"
          clearable
          :props="{ expandTrigger: 'hover',label:'orgname',value:'orgid',emitPath:false }"
          :show-all-levels="false"
        ></el-cascader>
        <el-cascader
          style="margin-left:10px"
          :options="experTreeList"
          v-model="checkParams.examquestioncheckid"
          @change="GetExamSumDataByClass"
          placeholder="请选择考核"
          clearable
          :props="{ expandTrigger: 'hover',label:'checkname',value:'examquestioncheckid',emitPath:false }"
          :show-all-levels="false"
        ></el-cascader>
      </div>
      <div class="sum">
        <div>
          及格率：<span>{{checkData.classrate}}</span>
        </div>
        <div>
          平均分：<span>{{checkData.classavgscore}}</span>
        </div>
      </div>
    </div>
    <div class="check_bottom">
      <el-table
        :data="checkData.stulist"
        stripe
        border
        max-height="624"
        tooltip-effect="dark"
        empty-text="请选择班级和考核"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="username"
          label="学生姓名"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="usercode"
          label="学生学号"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="classname"
          label="班级名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="操作次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="maxscore"
          label="最高成绩"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="minscore"
          label="最低成绩"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="avgscore"
          label="平均成绩"
          align="center"
        >
        </el-table-column>
      </el-table>
      <el-table
        :data="checkData.queslist"
        stripe
        border
        tooltip-effect="dark"
        empty-text="请选择班级和考核"
        style="width: 100%;margin-left:20px;"
      >
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="title"
          label="题目"
          width="180"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="count"
          label="总次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="okcount"
          label="答对次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="errcount"
          label="答错次数"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="okrate"
          label="正确率"
          align="center"
        >
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import Api from '../../api/index'

export default {
  data () {
    return {
      classList: [],
      experTreeList: [],
      checkParams: {
        classid: '',
        examquestioncheckid: ''
      },
      checkData: {}
    }
  },
  created () {
    this.GetOrgDataTree()
    this.GetExamSumDataByClass()
  },

  methods: {
    //获取系室专业班级树形图
    async GetOrgDataTree () {
      const res = await Api.organization.GetOrgDataTree()
      this.classList = res.rows
    },
    async GetExamQuestionCheckList () {
      const params = {
        type: 1,
        classid: this.checkParams.classid
      }
      const res = await Api.sum.GetExamQuestionCheckList(params)
      this.experTreeList = res.rows
    },
    //获取考核统计信息
    async GetExamSumDataByClass () {
      if (this.checkParams.classid != '') {
        this.GetExamQuestionCheckList()
      }
      const res = await Api.sum.GetExamSumDataByClass(this.checkParams)
      this.checkData = res.rows
    }
  }
}
</script>
<style lang='less' scoped>
.main {
  width: 100%;
  height: 100%;
  background: #fff;
  .check_top {
    display: flex;
    justify-content: space-between;
    padding: 15px 25px 15px 25px;
    .sum {
      display: flex;
      > div {
        margin-right: 20px;
        font-size: 15px;
        font-weight: 600;
        > span {
          color: coral;
        }
      }
    }
  }
  .check_bottom {
    display: flex;
    padding: 0 25px;
  }
}
</style>
